import { createFileRoute } from "@tanstack/react-router";
import { lazyNamed } from "@/lib/lazy-route";
import { COMMERCIAL_HEAT_PUMP_FAQS } from "@/components/landing/lp-commercial-heat-pumps";

import { breadcrumbJsonLdScript, commercialBreadcrumbTrail } from "@/lib/breadcrumbs";
import { pageSeo, serviceJsonLdScript } from "@/lib/seo";
import { SITE } from "@/lib/site";

const LpCommercialHeatPumpsPage = lazyNamed(
  () => import("@/components/landing/lp-commercial-heat-pumps"),
  "LpCommercialHeatPumps",
);

const PATH = "/commercial-heat-pumps";
const TITLE = "Heat Pump Retrofit Programmes South Wales & South West | MCS Certified | CRS Energy";
const DESCRIPTION =
 "MCS-certified air source heat pump delivery for social and off-gas stock, heat-loss designed, commissioned, framework-ready.";
const BREADCRUMB_NAME = "Heat Pump Retrofit Programmes";

export const Route = createFileRoute("/commercial-heat-pumps")({
 head: () => ({
 ...pageSeo({
 path: PATH,
 title: TITLE,
 description: DESCRIPTION,
 ogType: "article",
 }),
 scripts: [
 serviceJsonLdScript({
 name: BREADCRUMB_NAME,
 description: DESCRIPTION,
 serviceType: "Heat Pump Retrofit Programmes",
 url: `${SITE.url}${PATH}`,
 }),
 {
 type: "application/ld+json",
 children: JSON.stringify({
 "@context": "https://schema.org",
 "@type": "FAQPage",
 mainEntity: COMMERCIAL_HEAT_PUMP_FAQS.map((f) => ({
 "@type": "Question",
 name: f.question,
 acceptedAnswer: { "@type": "Answer", text: f.answer },
 })),
 }),
 },
 breadcrumbJsonLdScript(commercialBreadcrumbTrail(BREADCRUMB_NAME, PATH)),
 ],
 }),
 component: LpCommercialHeatPumpsPage,
});
